import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { OrganizationListFacade } from './organization-list.facade';

@Injectable({
  providedIn: 'root',
})
export class OrganizationListGuard {
  constructor(private organizationListFacade: OrganizationListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.organizationListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.organizationListFacade);
  }
}
